import React from "react";

export const SupportedImage = ({ title, url, image }) => {
  return (
    <div className="supported-item">
      <div className="">
        {" "}
        <a target="_blank" rel="noreferrer" href={url} title={title} data-lightbox-gallery="gallery1">
          <img src={image} className="img-responsive" alt={title} />{" "}
        </a>{" "}
      </div>
    </div>
  );
};
